import Glide from '@glidejs/glide';

// Testimonials
new Glide('#fp-testimonials-carousel', {
	type: 'carousel',
}).mount();